/**
 * Phase 0/1 single-locale dictionary (uk). Copy is externalised from day one so a
 * later swap to `next-intl` is additive, not a refactor.
 */
export const uk = {
  app: {
    name: "Безболісно",
    tagline: "центр відновлення спортсменів",
    product: "робоча памʼять спеціаліста",
  },
  nav: {
    dashboard: "Огляд",
    patients: "Пацієнти",
    tasks: "Задачі",
    schedule: "Розклад",
    analytics: "Аналітика",
    invoices: "Рахунки",
    gifts: "Сертифікати",
    pricing: "Ціни",
    profile: "Профіль",
    notifications: "Сповіщення",
  },
  shell: {
    menu: "Меню",
    closeMenu: "Закрити меню",
    navLabel: "Навігація",
    notifications: "Сповіщення",
    commandTrigger: "Пошук та дії",
    searchPatient: "Пошук пацієнта…",
    searching: "Шукаємо…",
    noPatientsFound: "Нікого не знайдено",
    filterView: "Фільтр пацієнтів",
    noneInFilter: "Немає пацієнтів у фільтрі.",
    pickPatient: "Обери пацієнта",
    pickPatientHint: "Обери картку зліва або натисни ⌘K, щоб швидко знайти людину чи виконати дію.",
    allTasks: "Усі відкриті задачі",
    noOpenTasks: "Відкритих задач немає.",
    analyticsSoon: "Детальніша аналітика зʼявиться у наступному релізі.",
    painTrend: "Тренд болю",
    quickTemplates: "Швидкі шаблони",
    episodesTab: "Епізоди",
    cardTab: "Картка",
    suggestChips: "швидке додавання:",
    sessionTimer: "ціль 1:30",
  },
  patient: {
    statusLabel: {
      new: "Новий",
      active: "Активний",
      paused: "На паузі",
      completed: "Завершив курс",
      maintenance: "Підтримуючий формат",
      archived: "Архів",
    },
  },
  clinical: {
    acute: "Гострий стан",
    irritable: "Подразнення",
    controlled: "Контрольований біль",
    return_to_load: "Повернення до навантаження",
    maintenance: "Підтримка / профілактика",
  },
  stages: [
    "Зменшення болю",
    "Базова сила",
    "Контроль руху",
    "Специфічне навантаження",
    "Повернення до спорту",
    "Підтримка",
  ],
  visitResult: {
    better: "Краще",
    partial: "Частково краще",
    no_change: "Без змін",
    worse: "Гірше",
    await_24h: "Чекаємо 24 год",
  },
  priority: {
    low: "Низький",
    medium: "Середній",
    high: "Високий",
  },
  taskStatus: {
    new: "Нове",
    in_progress: "В роботі",
    done: "Виконано",
    cancelled: "Скасовано",
  },
  patientStatus: {
    new: "Новий",
    active: "Активний",
    paused: "Пауза",
    completed: "Завершено",
    maintenance: "Підтримка",
    archived: "Архів",
  },
  patientForm: {
    back: "До списку",
    add: "Новий пацієнт",
    submit: "Створити пацієнта",
    sectionMain: "Основне",
    sectionContacts: "Контакти",
    sectionNotes: "Нотатки",
    firstName: "Імʼя",
    lastName: "Прізвище",
    status: "Статус",
    sport: "Спорт / активність",
    phone: "Телефон",
    telegram: "Telegram",
    instagram: "Instagram",
    email: "Email",
    serviceDetails: "Деталі послуги / уподобання",
    internalNotes: "Внутрішні нотатки",
    sportPlaceholder: "напр. біг, кросфіт, плавання",
    edit: "Редагувати",
    save: "Зберегти зміни",
    saving: "Зберігаємо…",
    archive: "Архівувати",
    restore: "Відновити",
    archivedNote: "Пацієнт в архіві — прихований з робочих списків.",
    archiveHint: "Пацієнта буде приховано з робочих списків. Дію можна скасувати відновленням.",
  },
  competitions: {
    add: "Додати старт",
    title: "Назва старту",
    date: "Дата старту",
    comment: "Коментар (необовʼязково)",
    empty: "Стартів поки немає — додайте перший.",
    past: "минув",
    today: "сьогодні",
    deleteTitle: "Видалити старт",
    next: "Найближчий",
  },
  appointments: {
    tab: "Прийоми",
    nextVisit: "Наступний прийом",
    book: "Записати на прийом",
    booking: "Записуємо…",
    date: "Дата прийому",
    time: "Час",
    duration: "Тривалість",
    minutes: "хв",
    comment: "Коментар (необовʼязково)",
    empty: "Запланованих прийомів немає.",
    move: "Перенести",
    moving: "Переносимо…",
    cancelOne: "Скасувати прийом",
    cancelling: "Скасовуємо…",
    noShow: "Не прийшов",
    noShowTitle: "Пацієнт не прийшов",
    noShowHint: "Прийом позначиться як пропущений. Дію можна скасувати поверненням броні.",
    cancelHint: "Бронь буде скасовано, нагадування — теж. Дію можна скасувати поверненням броні.",
    rebook: "Повернути бронь",
    status: {
      booked: "Заброньовано",
      done: "Відбувся",
      cancelled: "Скасовано",
      no_show: "Не прийшов",
    },
    startCapture: "Почати запис",
    startShort: "Почати",
    todayAgenda: "Розклад на сьогодні",
    agendaEmpty: "Сьогодні прийомів немає.",
    weekEmpty: "На цей тиждень прийомів немає.",
    prevWeek: "Попередній тиждень",
    nextWeek: "Наступний тиждень",
    thisWeek: "Поточний тиждень",
    jumpToday: "Сьогодні",
    free: "вільно",
    nowLabel: "зараз",
    pickPatient: "Знайдіть пацієнта за імʼям",
    changePatient: "Обрати іншого пацієнта",
    specialist: "Спеціаліст",
    allSpecialists: "Всі спеціалісти",
    patientsSpecialist: "Спеціаліст пацієнта",
    // Ukrainian plural forms for `<n> прийом(и/ів)`.
    countForms: ["прийом", "прийоми", "прийомів"],
  },
  episodeForm: {
    edit: "Редагувати епізод",
    title: "Назва епізоду",
    clinicalStatus: "Клінічний статус",
    hypothesis: "Гіпотеза",
    goal: "Ціль",
    painNow: "Біль зараз (0–10)",
    functionNow: "Функція зараз",
    redFlags: "Червоні прапорці",
    constraints: "Обмеження",
    stagePrev: "Попередній етап",
    stageNext: "Наступний етап",
    newEpisode: "Новий епізод",
    otherEpisodes: "Інші епізоди",
    activeEpisode: "Активний епізод",
    close: "Завершити епізод",
    closeHint: "Історія збережеться; епізод зникне з активної роботи.",
    closing: "Завершуємо…",
    reopen: "Відновити епізод",
    closedSection: "Завершені епізоди",
    closedBadge: "Завершено",
  },
  calendar: {
    placeholder: "Оберіть дату",
    today: "Сьогодні",
    clear: "Очистити",
    prevMonth: "Попередній місяць",
    nextMonth: "Наступний місяць",
    months: [
      "Січень",
      "Лютий",
      "Березень",
      "Квітень",
      "Травень",
      "Червень",
      "Липень",
      "Серпень",
      "Вересень",
      "Жовтень",
      "Листопад",
      "Грудень",
    ],
    monthsGen: [
      "січня",
      "лютого",
      "березня",
      "квітня",
      "травня",
      "червня",
      "липня",
      "серпня",
      "вересня",
      "жовтня",
      "листопада",
      "грудня",
    ],
    weekdays: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"],
  },
  workspace: {
    today: "Сьогодні",
    after: "Після прийому",
    history: "Історія",
    copyBrief: "Копіювати бриф",
    copied: "Скопійовано ✓",
    save: "Зберегти запис",
    saving: "Збереження…",
    saved: "Збережено ✓",
    more: "Більше полів",
    visitDate: "Дата візиту",
    painBefore: "Біль до",
    painAfter: "Біль після",
    result: "Реакція",
    done: "Що зробили",
    reaction: "Реакція / динаміка",
    worked: "Що спрацювало",
    notWorked: "Що не спрацювало",
    checkNext: "Що перевірити",
    nextPlan: "План на наступний візит",
    homework: "Домашнє завдання",
    write24: "Написати через 24 години",
    noEpisode: "Немає активного епізоду",
    createEpisode: "Створити епізод",
    episodeTitle: "Назва епізоду",
    tasksTab: "Задачі",
    templatesTab: "Шаблони",
    filesTab: "Файли",
    complete: "Виконано",
    addTask: "Додати задачу",
    taskTitle: "Назва задачі",
    addFile: "Додати файл / матеріал",
    fileTitleLabel: "Назва",
    fileLink: "Посилання (необовʼязково)",
    fileUpload: "Файл",
    dropHint: "Перетягніть файл сюди або натисніть, щоб обрати",
    dropSub: "Фото, відео, МРТ, УЗД, PDF — або додайте посиланням вище",
    startsTab: "Старти",
    deleteFileTitle: "Видалити файл",
    upload: "Додати",
    noTasks: "Відкритих задач немає",
    noFiles: "Файлів ще немає",
    open: "відкрити",
    copy: "Копіювати",
    aiTitle: "Надиктуй або встав сиру нотатку",
    aiHint: "AI структурує її прямо у поля форми — без окремого чату",
    aiStructure: "Структурувати",
    aiDictate: "Надиктувати",
    aiStructuring: "структурую…",
    aiReady: "готово · перевір і збережи",
    aiPatientMsg: "Повідомлення пацієнту",
    aiCoachMsg: "Резюме тренеру",
    aiCopy: "Копіювати",
    aiCopied: "Скопійовано ✓",
    rawPlaceholder:
      "напр.: коліно 3/10, зробили ізометрію, step-down, сідницю, після легше, наступного разу перевірити сходи і біг 20 хв…",
  },
  views: {
    all: "Всі",
    active: "Активні",
    action: "Потрібна дія",
    event: "Перед стартом",
    paused: "Пауза",
    archived: "Архів",
  },
  taskType: {
    message_post_visit: "Написати після процедури",
    check_24h: "Перевірити 24 год",
    event_reminder: "Нагадати про старт",
    offer_service: "Запропонувати послугу",
    update_plan: "Оновити план",
    request_media: "Попросити фото / відео",
    other: "Інше",
  },
  fileType: {
    photo: "Фото",
    video: "Відео",
    mri: "МРТ",
    ultrasound: "УЗД",
    xray: "Рентген",
    pdf: "PDF",
    training_screenshot: "Скрін тренування",
    movement_analysis: "Аналіз руху",
    other: "Інше",
  },
  role: {
    specialist: "Спеціаліст",
    admin: "Адміністратор",
    manager: "Менеджер",
    none: "Без ролі",
  },
  auth: {
    email: "Пошта",
    password: "Пароль",
    signIn: "Увійти",
    signingIn: "Вхід…",
    invalid: "Невірна пошта або пароль.",
    tooManyAttempts: "Забагато спроб входу. Зачекайте кілька секунд і спробуйте ще раз.",
    signOut: "Вийти",
    noRoleTitle: "Обліковий запис без ролі",
    noRoleBody:
      "Ваш акаунт створено, але роль ще не призначено. Зверніться до адміністратора клініки — після призначення ролі увійдіть знову.",
  },
  // The staff profile page (/profile): own name, password, active sessions.
  profile: {
    title: "Мій профіль",
    identity: "Особисті дані",
    nameLabel: "Імʼя",
    lastNameLabel: "Прізвище",
    nameHint: "Так вас бачать колеги у розкладі, задачах і рахунках.",
    emailLabel: "Пошта",
    roleLabel: "Роль",
    managedByAdmin: "Пошту та роль змінює адміністратор клініки.",
    save: "Зберегти",
    saving: "Зберігаємо…",
    saved: "Імʼя оновлено.",
    password: "Пароль",
    passwordHint: "Щонайменше 8 символів. Поточний пароль потрібен для підтвердження.",
    currentPassword: "Поточний пароль",
    newPassword: "Новий пароль",
    confirmPassword: "Повторіть новий пароль",
    revokeOthers: "Вийти на інших пристроях",
    changePassword: "Змінити пароль",
    changing: "Змінюємо…",
    changed: "Пароль змінено.",
    changedAndRevoked: "Пароль змінено, інші пристрої вийшли з системи.",
    sessions: "Активні сесії",
    sessionsHint: "Пристрої, на яких відкрито ваш акаунт. Завершена сесія одразу втрачає доступ.",
    thisDevice: "Цей пристрій",
    signedInAt: "Увійшли",
    unknownDevice: "Невідомий пристрій",
    revoke: "Завершити",
    revoking: "Завершуємо…",
    revokeOthersAction: "Вийти на всіх інших пристроях",
    noOtherSessions: "Інших активних сесій немає.",
    sessionRevoked: "Сесію завершено.",
    othersRevoked: "Інші пристрої вийшли з системи.",
    errors: {
      nameTooShort: "Вкажіть імʼя.",
      lastNameRequired: "Вкажіть прізвище.",
      nameTooLong: "Імʼя та прізвище — до 80 символів кожне.",
      wrongCurrent: "Поточний пароль невірний.",
      tooShort: "Новий пароль має містити щонайменше 8 символів.",
      tooLong: "Пароль має містити не більше 128 символів.",
      mismatch: "Паролі не збігаються.",
      currentRequired: "Введіть поточний пароль.",
      generic: "Не вдалося зберегти. Спробуйте ще раз.",
    },
  },
  dashboard: {
    greetingMorning: "Доброго ранку",
    greetingDay: "Доброго дня",
    greetingEvening: "Доброго вечора",
    specialistEyebrow: "Твій робочий день",
    adminEyebrow: "Панель адміністратора",
    managerEyebrow: "Операційний день клініки",
    newPatient: "Новий пацієнт",
    needsAction: "Потребують дії сьогодні",
    upcomingStarts: "Найближчі старти",
    activity: "Стрічка активності",
    open: "відкрито",
    noAction: "Все під контролем — відкритих задач немає.",
    noStarts: "Немає найближчих стартів.",
    noActivity: "Поки без активності.",
    inDays: "через",
    days: "дн.",
    stat: {
      myPatients: "Мої пацієнти",
      activePatients: "Активні пацієнти",
      needAction: "Потрібна дія",
      tasksToday: "Задачі на сьогодні",
      visitsWeek: "Візити цього тижня",
      nextStart: "Найближчі старти",
      nearestStart: "Найближчий старт",
      painProgress: "Середній прогрес болю",
      painHint: "по активних епізодах",
      inWork: "у активній роботі",
      todayHint: "встигни сьогодні",
      highHint: "високий пріоритет",
      startsHint: "у межах кількох тижнів",
      thisWeek: "за останні 7 днів",
      todayAppointments: "Прийоми сьогодні",
      agendaHint: "по всіх спеціалістах",
      unpaidInvoices: "Неоплачені рахунки",
      activeGifts: "Активні сертифікати",
      giftsHint: "залишок на балансах",
      monthPaid: "Оплачено цього місяця",
      monthHint: "за поточний місяць",
      unbilledVisits: "Невиставлені візити",
      unbilledHint: "≈ за базовими цінами",
      allBilled: "всі візити виставлено",
      unbilledExtra: (n: number) => ` · ще ${n} без рахунку`,
    },
  },
  common: {
    loadError: "Не вдалося завантажити дані. Оновіть сторінку або спробуйте пізніше.",
    adding: "Додаємо…",
    creating: "Створюємо…",
    uploading: "Завантажуємо…",
    cancel: "Скасувати",
    back: "Назад",
    dismiss: "Закрити",
    change: "Змінити",
    delete: "Видалити",
    deleting: "Видаляємо…",
    showAll: "Показати всі",
    showMore: "Показати ще",
    collapse: "Згорнути",
  },
  errors: {
    title: "Щось пішло не так",
    body: "Ми вже отримали звіт про помилку. Спробуйте ще раз або поверніться на головну.",
    retry: "Спробувати ще раз",
    home: "На головну",
    eventId: "Код помилки",
    notFoundTitle: "Сторінку не знайдено",
    notFoundBody: "Такої сторінки немає або її було переміщено.",
  },
  pager: {
    prev: "Попередні",
    next: "Наступні",
    of: (page: number, pages: number) => `Сторінка ${page} з ${pages}`,
  },
  analytics: {
    windowHint: "за останні 8 тижнів",
    visitsByWeek: "Візити за тижнями",
    painDynamics: "Динаміка болю",
    avgPainCaption: "середній біль після візиту",
    visitResults: "Реакція на візити",
    patientStatuses: "Статуси пацієнтів",
    clinicalStatuses: "Клінічні статуси епізодів",
    noData: "Замало даних для тренду.",
    dbError: "Не вдалося завантажити дані. Оновіть сторінку або спробуйте пізніше.",
    stat: {
      activePatients: "Активні пацієнти",
      totalPatients: "Всього пацієнтів",
      totalEpisodes: "Епізодів",
      totalVisits: "Всього візитів",
      visitsWeek: "Візити цього тижня",
      taskCompletion: "Виконання задач",
      painImprovement: "Покращення болю",
    },
    hint: {
      activePatients: "у активній роботі",
      totalEpisodes: "клінічних проблем під наглядом",
      visitsWeek: "за останні 7 днів",
      taskCompletion: "виконано з-поміж закритих",
      painImprovement: "по активних епізодах",
    },
  },
  tasksPage: {
    title: "Задачі",
    // Ukrainian plural forms [one, few, many] for `<n> задач(і) у вибірці`.
    resultCount: ["задача у вибірці", "задачі у вибірці", "задач у вибірці"],
    empty: "Задач за цим фільтром немає.",
    overdue: "Прострочено",
    noDue: "без терміну",
    markDone: "Завершити",
    finishTask: "Завершити задачу",
    finishing: "Завершуємо…",
    start: "В роботу",
    cancelTask: "Скасувати задачу",
    cancelling: "Скасовуємо…",
    cancelReasonPlaceholder: "Причина (необовʼязково)",
    reopen: "Відновити задачу",
    editTask: "Редагувати задачу",
    actions: "Дії",
    unassigned: "Без виконавця",
    comment: "Коментар",
    filterStatus: "Статус",
    filterPriority: "Пріоритет",
    filterDue: "Термін",
    filterType: "Тип",
    filterAssignee: "Виконавець",
    anyPriority: "Будь-який пріоритет",
    anyType: "Будь-який тип",
    anyAssignee: "Усі виконавці",
    statusOpt: {
      open: "Відкриті",
      all: "Усі",
      new: "Нове",
      in_progress: "В роботі",
      done: "Виконано",
      cancelled: "Скасовано",
    },
    dueOpt: {
      all: "Будь-коли",
      overdue: "Прострочені",
      today: "Сьогодні",
      week: "Цей тиждень",
      none: "Без терміну",
    },
  },
  // Sprint 9 — money surfaces. Derived visit payment states (never stored on visits).
  visitPayment: {
    unbilled: "Не виставлено",
    invoiced: "Виставлено",
    paid: "Оплачено",
    package: "Пакет",
  },
  pricing: {
    title: "Ціни",
    visitPrice: "Ціна візиту",
    noPrice: "Ціну ще не задано",
    setPrice: "Задати ціну",
    changePrice: "Змінити ціну",
    newPrice: "Нова ціна (грн)",
    save: "Зберегти",
    saving: "Зберігаємо…",
    effectiveFrom: "діє з",
    history: "Історія цін",
    perVisit: "за візит",
    readOnlyHint: "Ціни змінює адміністратор або менеджер.",
    packages: "Пакети візитів",
    addPackage: "Новий пакет",
    editPackage: "Редагувати пакет",
    packageTitle: "Назва пакета",
    visitCount: "Кількість візитів",
    discount: "Знижка (%)",
    packagePrice: "Ціна пакета",
    noPackages: "Пакетів ще немає.",
    priceFirstHint: "Спершу задайте ціну візиту.",
    archive: "Архівувати",
    archiveTitle: "Архівувати позицію",
    archiveHint: "Позиція зникне з продажу; продані пакети продовжують діяти.",
    promos: "Промо-акції",
    addPromo: "Нова акція",
    promoTitle: "Назва акції",
    startsOn: "Діє з",
    endsOn: "Діє до",
    scope: "Для кого",
    clinicWide: "Вся клініка",
    live: "діє зараз",
    upcoming: "очікує",
    expired: "минула",
    noPromos: "Акцій ще немає.",
    promoSingleVisitsHint:
      "Акції діють лише на разові візити і не сумуються — застосовується найбільша знижка.",
  },
  invoices: {
    title: "Рахунки",
    newInvoice: "Новий рахунок",
    number: "Номер",
    date: "Дата",
    patient: "Пацієнт",
    total: "Сума",
    statusLabel: "Статус",
    status: {
      issued: "Виставлено",
      paid: "Оплачено",
      void: "Анульовано",
    },
    filterStatus: {
      unpaid: "Неоплачені",
      all: "Усі",
      issued: "Виставлені",
      paid: "Оплачені",
      void: "Анульовані",
    },
    empty: "Рахунків за цим фільтром немає.",
    resultCount: ["рахунок у вибірці", "рахунки у вибірці", "рахунків у вибірці"],
    markPaid: "Позначити оплаченим",
    markPaidTitle: "Рахунок оплачено",
    markPaidHint: "Статус зміниться на «Оплачено», візити з рахунку стануть оплаченими.",
    paying: "Зберігаємо…",
    voidInvoice: "Анулювати",
    voidTitle: "Анулювати рахунок",
    voidHint: "Рахунок залишиться в історії, а візити знову можна буде виставити.",
    voiding: "Анулюємо…",
    issue: "Виставити рахунок",
    issuing: "Виставляємо…",
    pickPatientFirst: "Оберіть пацієнта, щоб виставити рахунок",
    unbilledVisits: "Невиставлені візити",
    noUnbilled: "Всі візити пацієнта вже виставлені або покриті абонементом.",
    customLine: "Довільна позиція",
    customTitle: "Опис позиції",
    amount: "Сума (грн)",
    lines: "Позиції",
    qty: "К-сть",
    unitPrice: "Ціна",
    lineDiscount: "Знижка",
    lineTotal: "Разом",
    totalDue: "До сплати",
    print: "Друк",
    nonFiscalNote: "Внутрішній документ. Не є фіскальним чеком.",
    visitLinePrefix: "Візит",
    applyGift: "Застосувати сертифікат",
    giftAutoPaidHint: "Коли сертифікати покривають всю суму, рахунок оплачується автоматично.",
    giftCode: "Код сертифіката",
    redeemGift: "Списати",
    redeeming: "Списуємо…",
    giftApplied: "Оплати сертифікатами",
    giftCovered: "покрито сертифікатом",
    giftWillCover: "Буде покрито сертифікатом",
    giftSaleNoRedeem: "Це рахунок продажу сертифіката — оплата сертифікатом недоступна.",
    giftAttachedHint: "Прикріплені сертифікати клієнта:",
    giftFunded: "сертифікат",
    giftReversed: "повернено на сертифікат",
    forPatientTitle: "Рахунки",
    noneForPatient: "Рахунків ще немає.",
    openInvoice: "Відкрити",
    // US-10: the billing worklist — the queue nobody can miss.
    worklistTitle: "До виставлення",
    worklistHint: "Візити без рахунку, найдавніші згори.",
    worklistCount: ["візит без рахунку", "візити без рахунку", "візитів без рахунку"],
    /** Short forms: the section title already says what these are. */
    visitForms: ["візит", "візити", "візитів"],
    appointmentForms: ["прийом", "прийоми", "прийомів"],
    agingTitle: (days: number) =>
      `Чекає ${days} ${plural(days, ["день", "дні", "днів"])} від дати візиту`,
    uncapturedTitle: "Чекають фіксації візиту",
    uncapturedHint: "Прийом відбувся, але запис візиту ще не збережено — рахунок поки неможливий.",
    uncapturedForms: ["прийом без запису", "прийоми без запису", "прийомів без запису"],
    scheduledTitle: "Заплановані прийоми",
    scheduledHint: "Очікуваний дохід. Передоплату можна взяти заздалегідь.",
    scheduledForms: ["запланований прийом", "заплановані прийоми", "запланованих прийомів"],
    prepayCta: "Передоплата",
    prepayCtaTitle: "Виставити рахунок-передоплату на цей прийом",
    // Prepayment: bill a booked appointment before the visit happens.
    prepaySection: "Заплановані прийоми (передоплата)",
    prepayHint:
      "Не обовʼязково: рахунок на майбутній прийом. Після фіксації візиту оплата перейде на нього автоматично.",
    prepayLinePrefix: "Прийом",
    prepayQuickHint: "Рахунок-передоплата на цей прийом за поточною ціною.",
    worklistPatientCta: "Виставити рахунок",
    quickIssue: "Виставити",
    quickIssueTitle: "Виставити рахунок",
    quickIssueHint: "Разовий рахунок на цей візит за поточною ціною.",
    quickIssued: "Рахунок виставлено",
    priceMissing: "ціну не задано",
    setPriceCta: "Задати ціну",
    // 2026 UX pass
    dueLeft: "Залишок до сплати",
    issuedAtLabel: "Виставлено",
    paidAtLabel: "Оплачено",
    voidAtLabel: "Анульовано",
    selectAll: "Обрати всі",
    clearAll: "Зняти всі",
    removeLine: "Прибрати позицію",
    visitsSection: "Візити",
    selectedForms: ["позиція", "позиції", "позицій"],
    suggestTitle: "З черги «До виставлення»",
    suggestHint: "Один дотик — і візити вже відмічені в рахунку.",
    orSearch: "або знайдіть пацієнта",
  },
  gifts: {
    title: "Сертифікати",
    newGift: "Новий сертифікат",
    create: "Створити сертифікат",
    creating: "Створюємо…",
    amount: "Номінал (грн)",
    modeLabel: "Тип номіналу",
    modeAmount: "Сума в гривнях",
    modeVisits: "Кількість візитів",
    visitsCount: "Візитів",
    specialist: "Спеціаліст",
    visitsPreview: "Номінал розрахуємо за поточною ціною візиту спеціаліста.",
    nominal: "номінал",
    // Ukrainian plural forms for `<n> візит(и/ів)` on the card artwork.
    visitForms: ["візит", "візити", "візитів"],
    purchaser: "Замовник",
    recipient: "Кому (необовʼязково)",
    message: "Побажання (необовʼязково)",
    expires: "Діє до (необовʼязково)",
    code: "Код",
    initial: "Номінал",
    balance: "Залишок",
    status: {
      active: "Активний",
      redeemed: "Використано",
      expired: "Прострочений",
      void: "Анульовано",
      awaiting_payment: "Очікує оплати",
      sale_void: "Продаж анульовано",
    },
    voidCard: "Анулювати",
    voidTitle: "Анулювати сертифікат",
    voidHint: "Сертифікат більше не можна буде застосувати до рахунків.",
    voiding: "Анулюємо…",
    exportPng: "Завантажити PNG",
    print: "Друкувати",
    empty: "Сертифікатів ще немає.",
    resultCount: ["сертифікат у вибірці", "сертифікати у вибірці", "сертифікатів у вибірці"],
    redemptions: "Історія списань",
    noRedemptions: "Списань ще не було.",
    validUntil: "діє до",
    noExpiry: "безстроковий",
    cardKicker: "Подарунковий сертифікат",
    cardService: "на послуги центру відновлення спортсменів",
    cardFor: "Для",
    cardCodeLabel: "код",
    searchPlaceholder: "Пошук за кодом, замовником чи клієнтом…",
    // Paid-gate: the certificate works only after its sale invoice is paid.
    awaitingPayHint: "Сертифікат ще не оплачено — застосування до рахунків заблоковано.",
    saleVoidHint: "Рахунок продажу анульовано — сертифікат недійсний.",
    openSaleInvoice: "Відкрити рахунок на оплату",
    saleInvoice: "Рахунок продажу",
    // Live preview on /gifts/new.
    previewHint: "Так виглядатиме сертифікат — оновлюється під час введення.",
    codePlaceholderNote: "Код згенерується після створення.",
    expiryNone: "Безстроковий",
    expiry6m: "6 місяців",
    expiry12m: "12 місяців",
    expiryCustom: "Інша дата",
    // Client binding (one certificate — one client).
    bindPatient: "Прикріпити до клієнта (необовʼязково)",
    bindPatientHint: "Сертифікат зможе використовувати лише цей клієнт.",
    boundTo: "Клієнт",
    unbound: "Без привʼязки",
    forPatientTitle: "Подарункові сертифікати",
    attachByCode: "Прикріпити за кодом",
    attach: "Прикріпити",
    attaching: "Прикріпляємо…",
    detach: "Відкріпити",
    detaching: "Відкріпляємо…",
    attachedEmpty: "Прикріплених сертифікатів немає.",
    autoApplyHint:
      "Прикріплені сертифікати автоматично застосуються під час виставлення наступного рахунку.",
    reversed: "повернено",
  },
  packages: {
    forPatientTitle: "Пакети візитів",
    sell: "Продати пакет",
    selling: "Продаємо…",
    pickPackage: "Оберіть пакет",
    left: "залишилось",
    redeemChip: "Списати з пакета",
    status: {
      active: "Активний",
      exhausted: "Використано",
      cancelled: "Скасовано",
    },
    cancelPackage: "Скасувати пакет",
    cancelTitle: "Скасувати пакет",
    cancelHint: "Залишок візитів згорить. Історія використаних візитів збережеться.",
    cancelling: "Скасовуємо…",
    empty: "Пакетів ще немає.",
    noneToSell: "У спеціаліста пацієнта немає активних пакетів у прайсі.",
    visitsOf: (used: number, total: number) => `${used}/${total} візитів`,
  },
  telegram: {
    // Bot replies
    welcome:
      "Вітаємо в «Безболісно»! Щоб бачити свої записи та пакети, відкрийте посилання з картки пацієнта, яке дасть спеціаліст.",
    linked: (name: string) =>
      `Готово, ${name}! Ваш Telegram привʼязано. Відкрийте застосунок кнопкою нижче.`,
    linkInvalid: "Код недійсний або прострочений. Попросіть у спеціаліста нове посилання.",
    linkTaken: "Цей Telegram уже привʼязано до іншого пацієнта. Зверніться до клініки.",
    openApp: "Відкрити застосунок",
    // Notifications (worker)
    booked: (when: string) => `Вас записано на прийом: ${when}. До зустрічі!`,
    rescheduled: (when: string) => `Ваш прийом перенесено на ${when}. Чекаємо на вас!`,
    cancelled: (when: string) =>
      `На жаль, прийом ${when} скасовано. Напишіть або зателефонуйте в клініку, щоб обрати інший час.`,
    reminderBooking: (when: string) => `Нагадуємо: завтра прийом — ${when}.`,
    reminderFollowUp:
      "Як самопочуття після вчорашньої процедури? Напишіть спеціалісту, якщо щось турбує.",
    // Mini App
    appTitle: "Безболісно",
    notLinkedTitle: "Акаунт не привʼязано",
    notLinkedBody:
      "Попросіть спеціаліста надіслати посилання для привʼязки з вашої картки пацієнта.",
    nextVisit: "Наступний прийом",
    noUpcoming: "Записів поки немає",
    packages: "Пакети",
    invoices: "Рахунки",
    profile: "Профіль",
    loading: "Завантаження…",
    // Honest about what the app knows: it could not get an answer, nothing more.
    failedTitle: "Не вдалося завантажити",
    failedBody: "Перевірте зʼєднання і спробуйте ще раз. Якщо не допомагає — напишіть у клініку.",
    // The staff list says "за цим фільтром" — the Mini App shows every invoice, unfiltered.
    noInvoices: "Рахунків поки немає.",
  },
  // Transactional email (worker): words only — no markup, no colours. The renderer in
  // packages/infra owns the layout and the one footer; the shapes are `EmailCopy` in core.
  email: {
    common: {
      auto: "Лист надіслано автоматично — відповідати на нього не потрібно. Якщо є питання, звʼяжіться з клінікою у звичний спосіб.",
      legal: (year: number) => `© ${year} Безболісно · центр відновлення спортсменів`,
    },
    booked: {
      eyebrow: "Запис",
      subject: (when: string) => `Вас записано на прийом — ${when}`,
      preheader: (when: string) => `Чекаємо на вас: ${when}`,
      title: (firstName: string) => `${firstName}, вас записано на прийом`,
      body: "Ми зарезервували для вас час у «Безболісно». Деталі нижче — збережіть лист, щоб не загубити.",
      when: "Коли",
      duration: "Тривалість",
      durationValue: (min: number) => `${min} хв`,
      specialist: "Спеціаліст",
      note: "Якщо плани зміняться — попередьте клініку заздалегідь, щоб ми могли запропонувати цей час комусь іншому.",
    },
    rescheduled: {
      eyebrow: "Перенесення",
      subject: (when: string) => `Прийом перенесено — ${when}`,
      preheader: (when: string) => `Новий час: ${when}`,
      title: (firstName: string) => `${firstName}, ваш прийом перенесено`,
      body: "Час прийому змінився. Нижче — як було і як стало.",
      was: "Було",
      now: "Стало",
      specialist: "Спеціаліст",
      note: "Якщо новий час не підходить — напишіть або зателефонуйте в клініку, підберемо інший.",
    },
    cancelled: {
      eyebrow: "Скасування",
      subject: (when: string) => `Прийом скасовано — ${when}`,
      preheader: "Оберіть інший час, коли буде зручно",
      title: (firstName: string) => `${firstName}, прийом скасовано`,
      body: (when: string) =>
        `На жаль, прийом ${when} не відбудеться. Перепрошуємо за незручності.`,
      note: "Щоб записатися на інший час, напишіть або зателефонуйте в клініку.",
    },
    reminder: {
      eyebrow: "Нагадування",
      subject: (when: string) => `Нагадуємо: завтра прийом — ${when}`,
      preheader: "До зустрічі завтра у «Безболісно»",
      title: (firstName: string) => `${firstName}, нагадуємо про прийом`,
      body: "Завтра на вас чекає спеціаліст. Час і деталі нижче.",
      when: "Коли",
      specialist: "Спеціаліст",
      note: "Не встигаєте? Напишіть або зателефонуйте в клініку — перенесемо на зручний час.",
    },
    followUp: {
      eyebrow: "Самопочуття",
      subject: "Як самопочуття після процедури?",
      preheader: "Одне коротке запитання від вашого спеціаліста",
      title: (firstName: string) => `${firstName}, як ви сьогодні?`,
      body: "Минула доба після процедури. Якщо щось турбує — біль посилився, зʼявився набряк або незвичний дискомфорт — напишіть спеціалісту, не чекаючи наступного візиту.",
      note: "Якщо все добре — чудово, продовжуйте домашні вправи за планом.",
    },
  },
  // /settings/notifications (docs/PLAN-notification-settings.md §6)
  notificationsSettings: {
    title: "Сповіщення",
    intro:
      "Що клініка надсилає пацієнтам і якими каналами. Зміни діють одразу — наступне сповіщення піде за новими правилами.",
    mode: {
      label: "Доставка",
      first: "Перший доступний канал",
      all: "Усі увімкнені канали",
      hintFirst: "Пацієнт отримує одне повідомлення: Telegram, якщо привʼязано, інакше email.",
      hintAll: "Пацієнт отримує повідомлення кожним увімкненим каналом, де є контакт.",
    },
    groups: { appointments: "Прийоми", visits: "Візити" },
    kinds: {
      "appointment.booked": {
        title: "Підтвердження запису",
        when: "одразу після запису на прийом",
      },
      "appointment.rescheduled": {
        title: "Перенесення прийому",
        when: "коли змінюється час прийому",
      },
      "appointment.cancelled": {
        title: "Скасування прийому",
        when: "коли клініка скасовує прийом",
      },
      "appointment.reminder": {
        title: "Нагадування про прийом",
        when: "заздалегідь перед прийомом",
      },
      "visit.follow_up": {
        title: "Як самопочуття",
        when: "через добу після візиту з позначкою «написати через 24 год»",
      },
    },
    channels: { telegram: "Telegram", email: "Email" },
    channelState: { on: "увімкнено", off: "вимкнено", unavailable: "не налаштовано" },
    enabled: "Увімкнено",
    disabled: "Вимкнено",
    leadHours: "Нагадувати за",
    hours: (h: number) => `${h} год`,
    leadRule: (h: number) => `Запис менш ніж за ${h} год — без нагадування.`,
    previewAction: "Переглянути",
    preview: {
      title: "Попередній перегляд",
      select: "Оберіть сповіщення ліворуч, щоб побачити, що отримає пацієнт.",
      subject: "Тема",
      light: "Світла",
      dark: "Темна",
      desktop: "Компʼютер",
      phone: "Телефон",
      sample: (firstName: string, when: string, specialist: string) =>
        `Зразок даних: ${firstName}, ${when}, ${specialist}.`,
      sendTest: "Надіслати тестовий лист",
      testTo: "Кому надіслати тест",
      sent: (to: string) => `Тестовий лист надіслано на ${to}`,
      loading: "Готуємо перегляд…",
      failed: "Не вдалося показати перегляд.",
      botName: "Безболісно",
    },
    log: {
      title: "Останні надсилання",
      empty: "Поки нічого не надсилали.",
      columns: {
        when: "Коли",
        kind: "Сповіщення",
        patient: "Пацієнт",
        channel: "Канал",
        status: "Статус",
      },
      status: { sent: "Надіслано", skipped: "Пропущено", failed: "Помилка" },
      reasons: {
        kind_disabled: "сповіщення вимкнено",
        channel_off: "канал вимкнено",
        channel_unavailable: "канал не налаштовано",
        no_contact: "немає контакту",
        unknown_patient: "пацієнта не знайдено",
        already_sent: "уже надіслано",
        mode_first: "доставлено іншим каналом",
      },
    },
    saved: "Збережено",
    conflict: "Хтось уже змінив налаштування — сторінку оновлено, повторіть зміну.",
    saveFailed: "Не вдалося зберегти. Спробуйте ще раз.",
    updatedBy: (name: string, when: string) => `Змінено: ${name}, ${when}`,
    neverChanged: "Типові налаштування — ще ніхто не змінював.",
  },
  activityLabel: {
    "account.update": "Оновлено профіль",
    "account.password_change": "Змінено пароль",
    "account.sessions_revoke": "Завершено сесії",
    "notifications.policy_update": "Змінено налаштування сповіщень",
    "notifications.test_send": "Надіслано тестовий лист",
    "ai.structure": "AI структурував нотатку",
    "visit.record": "Записано візит",
    "visit.update": "Візит відкориговано",
    "task.create": "Нова задача",
    "task.start": "Задачу взято в роботу",
    "task.complete": "Задачу виконано",
    "task.cancel": "Задачу скасовано",
    "task.reopen": "Задачу відновлено",
    "task.update": "Задачу оновлено",
    "file.add": "Додано матеріал",
    "file.update": "Матеріал оновлено",
    "file.delete": "Матеріал видалено",
    "patient.create": "Новий пацієнт",
    "patient.update": "Картку пацієнта оновлено",
    "patient.archive": "Пацієнта архівовано",
    "patient.restore": "Пацієнта відновлено з архіву",
    "episode.create": "Новий епізод",
    "episode.update": "Епізод оновлено",
    "episode.stage_advance": "Етап реабілітації підвищено",
    "episode.stage_regress": "Етап реабілітації знижено",
    "episode.close": "Епізод завершено",
    "episode.reopen": "Епізод відновлено",
    "appointment.book": "Прийом заброньовано",
    "appointment.move": "Прийом перенесено",
    "appointment.cancel": "Прийом скасовано",
    "appointment.no_show": "Пацієнт не прийшов на прийом",
    "appointment.rebook": "Бронь відновлено",
    "appointment.complete": "Прийом відбувся",
    "competition.create": "Додано старт",
    "competition.update": "Старт оновлено",
    "competition.delete": "Старт видалено",
    "auth.denied": "Відмовлено в доступі",
    "pricing.set_price": "Оновлено ціну візиту",
    "pricing.package_save": "Збережено пакет візитів",
    "pricing.package_archive": "Пакет візитів архівовано",
    "pricing.promo_save": "Збережено промо-акцію",
    "pricing.promo_archive": "Промо-акцію архівовано",
    "invoice.issue": "Виставлено рахунок",
    "invoice.paid": "Рахунок оплачено",
    "invoice.void": "Рахунок анульовано",
    "gift.create": "Створено подарунковий сертифікат",
    "gift.redeem": "Сертифікат застосовано до рахунку",
    "gift.void": "Сертифікат анульовано",
    "gift.attach": "Сертифікат прикріплено до клієнта",
    "gift.detach": "Сертифікат відкріплено від клієнта",
    "gift.redemption_reversed": "Списання повернено на сертифікат",
    "package.sell": "Продано пакет візитів",
    "package.cancel": "Пакет візитів скасовано",
  },
  entityLabel: {
    patient: "Пацієнт",
    episode: "Епізод",
    visit: "Візит",
    task: "Задача",
    file: "Файл",
    competition: "Старт",
    appointment: "Прийом",
    permission: "Доступ",
    invoice: "Рахунок",
    gift_card: "Сертифікат",
    package: "Пакет візитів",
    price: "Ціна",
    promo: "Акція",
  },
} as const;

export type Dict = typeof uk;
export const t = uk;

/**
 * Ukrainian plural selection. `forms` is [one, few, many]:
 *   1 задача · 2–4 задачі · 5+ задач (and 11–14 → many).
 */
export function plural(n: number, forms: readonly [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
}
